var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatInSpace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "saiki_stories-cat-astronaut",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    svg#saiki_stories-cat-astronaut:not(.animated) .animable {\n      opacity: 0;\n    }\n\n    svg#saiki_stories-cat-astronaut.animated #saiki--Cat--inject-2 {\n      animation: 6s Infinite linear floating;\n      animation-delay: 0s;\n    }\n\n    svg#saiki_stories-cat-astronaut.animated #saiki--Yarn--inject-2 {\n      animation: 3s Infinite linear floating;\n      animation-delay: 0s;\n    }\n\n    @keyframes floating {\n      0% {\n        opacity: 1;\n        transform: translateY(0px);\n      }\n\n      50% {\n        transform: translateY(-10px);\n      }\n\n      100% {\n        opacity: 1;\n        transform: translateY(0px);\n      }\n    }\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "saiki--background-simple--inject-2",
    className: "animable",
    style: {
      transformOrigin: "246.23px 249.217px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.05,243.37c-4.91,41.6-23.91,90-61.85,112.21-57.33,33.58-52.53,85.24-164.43,107.7A230.34,230.34,0,0,1,191.15,468a191.22,191.22,0,0,1-24.35-2c-71.12-10.39-119-59.83-136.54-119.5C7.16,268,53.3,216.62,83.88,185.66s53-127.41,162.81-150.35a222.84,222.84,0,0,1,51-4.85c39.08,1,81.7,13.79,111.2,40.58q3.31,3,6.46,6.24C456.34,119.36,473.76,186.64,467.05,243.37Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "246.23px 249.217px"
    },
    id: "elmat7hhsnmrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbnjtjpa4m9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.05,243.37c-4.91,41.6-23.91,90-61.85,112.21-57.33,33.58-52.53,85.24-164.43,107.7A230.34,230.34,0,0,1,191.15,468a191.22,191.22,0,0,1-24.35-2c-71.12-10.39-119-59.83-136.54-119.5C7.16,268,53.3,216.62,83.88,185.66s53-127.41,162.81-150.35a222.84,222.84,0,0,1,51-4.85c39.08,1,81.7,13.79,111.2,40.58q3.31,3,6.46,6.24C456.34,119.36,473.76,186.64,467.05,243.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "246.23px 249.217px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "saiki--Stars--inject-2",
    className: "animable",
    style: {
      transformOrigin: "262.961px 256.487px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "144.68 71.59 141.84 81.22 148.16 89.03 138.12 89.3 132.65 97.73 129.29 88.26 119.58 85.67 127.55 79.54 127.02 69.51 135.3 75.19 144.68 71.59",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "133.87px 83.62px"
    },
    id: "elr8zfxyszd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.65,98.23h-.06a.51.51,0,0,1-.41-.33l-3.27-9.22-9.46-2.53a.51.51,0,0,1-.36-.39.52.52,0,0,1,.19-.49l7.76-6-.52-9.77a.53.53,0,0,1,.25-.47.51.51,0,0,1,.53,0l8.07,5.53,9.13-3.51a.5.5,0,0,1,.52.1.49.49,0,0,1,.14.51l-2.77,9.38,6.16,7.6a.5.5,0,0,1-.37.82l-9.78.27L133.07,98A.48.48,0,0,1,132.65,98.23Zm-12-12.78,8.73,2.33a.48.48,0,0,1,.34.32l3,8.51L137.7,89a.51.51,0,0,1,.41-.23l9-.24-5.69-7a.51.51,0,0,1-.09-.46l2.56-8.66-8.44,3.24a.48.48,0,0,1-.46-.06l-7.45-5.1.48,9a.5.5,0,0,1-.2.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "133.875px 83.5929px"
    },
    id: "el3kjjlphzimy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.79 104.08 338.68 107.1 337.7 113.84 332.94 108.96 326.22 110.12 329.4 104.08 326.22 98.05 332.94 99.2 337.7 94.32 338.68 101.07 344.79 104.08",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "335.505px 104.08px"
    },
    id: "elj3s6tr9p7el",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.7,114.34a.48.48,0,0,1-.36-.15l-4.57-4.69-6.46,1.11a.5.5,0,0,1-.53-.73l3.05-5.8-3.05-5.8a.49.49,0,0,1,0-.52.5.5,0,0,1,.49-.2l6.46,1.11L337.34,94a.5.5,0,0,1,.85.27l.94,6.49,5.88,2.9a.49.49,0,0,1,.28.44.5.5,0,0,1-.28.45l-5.88,2.9-.94,6.49a.5.5,0,0,1-.34.4A.39.39,0,0,1,337.7,114.34Zm-4.76-5.88a.55.55,0,0,1,.36.15l4.05,4.16.83-5.74a.52.52,0,0,1,.28-.38l5.2-2.57-5.2-2.56a.54.54,0,0,1-.28-.38l-.83-5.74-4.05,4.15a.49.49,0,0,1-.44.15l-5.72-1,2.7,5.13a.49.49,0,0,1,0,.47l-2.7,5.13,5.72-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.498px 104.099px"
    },
    id: "elbqirz0g5y2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.37 270.84 460.77 275.64 462.12 282.15 456.13 279.26 450.36 282.56 451.25 275.97 446.34 271.5 452.88 270.31 455.61 264.26 458.76 270.11 465.37 270.84",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "455.855px 273.41px"
    },
    id: "elmlwesilj5xg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.36,283.06a.47.47,0,0,1-.28-.09.51.51,0,0,1-.22-.48l.86-6.33L446,271.87a.49.49,0,0,1-.14-.51.48.48,0,0,1,.39-.35l6.28-1.14,2.63-5.82a.47.47,0,0,1,.43-.29.5.5,0,0,1,.46.26l3,5.62,6.35.7a.51.51,0,0,1,.42.33.5.5,0,0,1-.11.51l-4.42,4.62,1.3,6.25a.49.49,0,0,1-.18.49.51.51,0,0,1-.53.06l-5.75-2.77L450.61,283A.59.59,0,0,1,450.36,283.06Zm-2.94-11.25,4.17,3.79a.51.51,0,0,1,.16.44l-.76,5.58,4.89-2.79a.52.52,0,0,1,.47,0l5.07,2.45-1.14-5.52a.5.5,0,0,1,.13-.45l3.89-4.07-5.6-.61a.52.52,0,0,1-.38-.26l-2.67-5-2.32,5.14a.49.49,0,0,1-.36.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "455.843px 273.41px"
    },
    id: "el5ermgpaynxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.33 407.66 228.95 413.98 230.53 422.82 222.55 418.7 214.64 422.94 216.09 414.08 209.61 407.86 218.49 406.5 222.4 398.42 226.43 406.44 235.33 407.66",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "222.47px 410.68px"
    },
    id: "elrwsqzr9l5lq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.64,423.44a.43.43,0,0,1-.29-.1.48.48,0,0,1-.21-.48l1.41-8.6-6.29-6a.51.51,0,0,1,.27-.86l8.62-1.31,3.8-7.85a.49.49,0,0,1,.44-.28.51.51,0,0,1,.46.27l3.91,7.79,8.64,1.19a.5.5,0,0,1,.28.85l-6.19,6.13,1.53,8.58a.49.49,0,0,1-.19.49.51.51,0,0,1-.53,0l-7.74-4-7.69,4.12A.46.46,0,0,1,214.64,423.44Zm-3.95-15.24,5.74,5.52a.49.49,0,0,1,.15.44L215.29,422l7-3.76a.5.5,0,0,1,.46,0l7.08,3.66-1.41-7.84a.54.54,0,0,1,.15-.45l5.66-5.6-7.89-1.09a.47.47,0,0,1-.38-.27l-3.58-7.11-3.47,7.17a.5.5,0,0,1-.38.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "222.47px 410.7px"
    },
    id: "el1ncwr0f28cp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.24 305.9 87.45 310.72 90.98 314.1 86.15 314.84 84.03 319.24 81.83 314.88 76.99 314.22 80.46 310.78 79.59 305.97 83.94 308.21 88.24 305.9",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "83.985px 312.57px"
    },
    id: "elor2gzy7pyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,319.74a.49.49,0,0,1-.45-.27l-2.08-4.13-4.58-.63a.5.5,0,0,1-.41-.34.49.49,0,0,1,.13-.51l3.28-3.25-.82-4.55a.5.5,0,0,1,.72-.53l4.11,2.11L88,305.46a.49.49,0,0,1,.52,0,.5.5,0,0,1,.21.49L88,310.54l3.34,3.2a.51.51,0,0,1-.27.86l-4.57.7-2,4.16a.51.51,0,0,1-.45.28Zm-6-5.88,3.84.52a.54.54,0,0,1,.38.28L84,318.11l1.68-3.48a.51.51,0,0,1,.38-.28l3.82-.59-2.79-2.68a.51.51,0,0,1-.15-.44l.63-3.82-3.42,1.83a.47.47,0,0,1-.46,0l-3.44-1.77.68,3.81a.48.48,0,0,1-.14.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "83.9714px 312.563px"
    },
    id: "el6f7jol2ivcr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.67 470.94 147.12 468.89 143.43 470.65 144.28 466.65 141.47 463.67 145.54 463.25 147.5 459.65 149.16 463.39 153.19 464.15 150.14 466.88 150.67 470.94",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "147.33px 465.295px"
    },
    id: "elrahttdhgdx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.67,471.45a.55.55,0,0,1-.25-.07l-3.32-1.92-3.46,1.64a.49.49,0,0,1-.53-.06.5.5,0,0,1-.17-.49l.8-3.75L141.1,464a.5.5,0,0,1-.1-.52.48.48,0,0,1,.41-.32l3.81-.4,1.84-3.37a.55.55,0,0,1,.46-.26.5.5,0,0,1,.43.3l1.56,3.5,3.77.71a.49.49,0,0,1,.24.86l-2.85,2.56.49,3.8a.5.5,0,0,1-.49.57Zm-3.55-3.06a.52.52,0,0,1,.25.07L150,470l-.4-3.05a.52.52,0,0,1,.16-.44l2.3-2.06-3-.56a.52.52,0,0,1-.37-.29l-1.25-2.82L146,463.49a.53.53,0,0,1-.39.26l-3.07.32,2.12,2.23a.5.5,0,0,1,.13.45l-.64,3,2.78-1.33A.54.54,0,0,1,147.12,468.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "147.331px 465.29px"
    },
    id: "elko3x6l7ftjj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.85 174.21 68.29 172.66 64.42 175.54 64.49 170.72 60.55 167.94 65.15 166.51 66.58 161.91 69.37 165.84 74.18 165.78 71.3 169.64 72.85 174.21",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "67.365px 168.725px"
    },
    id: "elf7dhcz628g6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.42,176a.59.59,0,0,1-.22,0,.52.52,0,0,1-.28-.46L64,171l-3.72-2.63a.51.51,0,0,1-.2-.49.5.5,0,0,1,.34-.4l4.35-1.35,1.36-4.35a.47.47,0,0,1,.4-.34.47.47,0,0,1,.48.2l2.63,3.72,4.56-.06a.5.5,0,0,1,.4.8l-2.72,3.65,1.46,4.32a.48.48,0,0,1-.12.51.5.5,0,0,1-.51.12l-4.32-1.46-3.65,2.72A.45.45,0,0,1,64.42,176Zm-2.75-7.92,3.1,2.19a.51.51,0,0,1,.22.42l0,3.8,3-2.27a.47.47,0,0,1,.46-.07l3.6,1.22-1.22-3.61a.51.51,0,0,1,.07-.46l2.28-3.05-3.81.05a.47.47,0,0,1-.41-.21L66.76,163l-1.13,3.64a.5.5,0,0,1-.33.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "67.3868px 168.722px"
    },
    id: "el1mfa6xifhlk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.39 175.06 449.33 174.53 446.59 177.58 445.84 173.55 442.1 171.89 445.7 169.93 446.12 165.86 449.1 168.67 453.1 167.82 451.34 171.52 453.39 175.06",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "447.745px 171.72px"
    },
    id: "ele4vk1i37ywu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.59,178.08l-.13,0a.51.51,0,0,1-.36-.39l-.7-3.77-3.5-1.55a.5.5,0,0,1-.3-.44.49.49,0,0,1,.26-.46l3.37-1.83.39-3.81a.51.51,0,0,1,.33-.42.48.48,0,0,1,.51.1l2.79,2.64,3.75-.8a.48.48,0,0,1,.49.18.49.49,0,0,1,.06.52l-1.64,3.46,1.92,3.32a.53.53,0,0,1,0,.53.51.51,0,0,1-.48.22l-3.8-.5L447,177.91A.52.52,0,0,1,446.59,178.08Zm-3.36-6.24,2.82,1.26a.47.47,0,0,1,.28.36l.57,3L449,174.2a.48.48,0,0,1,.44-.16l3.05.4-1.54-2.67a.52.52,0,0,1,0-.47l1.32-2.78-3,.64a.49.49,0,0,1-.45-.12l-2.24-2.12-.32,3.06a.48.48,0,0,1-.25.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "447.75px 171.728px"
    },
    id: "el1klr7v1678o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.95 52.77 274.75 48.72 272.43 44.94 276.85 45.4 279.72 42.02 280.65 46.36 284.75 48.06 280.91 50.28 280.57 54.7 277.27 51.74 272.95 52.77",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "278.59px 48.36px"
    },
    id: "eldvder9a2iaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.57,55.2a.5.5,0,0,1-.34-.13l-3.1-2.79-4.06,1a.52.52,0,0,1-.5-.16.51.51,0,0,1-.07-.53l1.69-3.81L272,45.2a.51.51,0,0,1,0-.53.52.52,0,0,1,.48-.23l4.15.43,2.7-3.17a.5.5,0,0,1,.87.22l.88,4.08,3.85,1.59a.5.5,0,0,1,.31.43.51.51,0,0,1-.25.47l-3.61,2.09-.32,4.16a.5.5,0,0,1-.32.42A.39.39,0,0,1,280.57,55.2Zm-3.3-4a.5.5,0,0,1,.33.12l2.55,2.29.26-3.41a.52.52,0,0,1,.25-.39l3-1.72-3.16-1.31a.5.5,0,0,1-.3-.35l-.71-3.35-2.22,2.6a.52.52,0,0,1-.44.18l-3.4-.36,1.79,2.92a.47.47,0,0,1,0,.46l-1.39,3.13,3.33-.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "278.583px 48.362px"
    },
    id: "els986fozyemj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "saiki--Cat--inject-2",
    className: "animable",
    style: {
      transformOrigin: "281.872px 222.644px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.7,139.6s-38-15.71-78.13,13.64-16.12,74.83-5,83.92,26,22,67.75,13.29S281.74,219,281.74,195,271.82,150.35,243.7,139.6Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "212.491px 194.37px"
    },
    id: "elyi5hypn9b8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.25,253.83c-23,0-33.88-8.88-42.36-15.8l-.6-.48c-6.37-5.19-18.06-23.53-17.52-44.32.42-16.18,8-29.77,22.51-40.39,39.69-29.06,77.9-14,78.61-13.71,25.45,9.73,38.35,28.53,38.35,55.86,0,29.71-18.09,48.53-53.78,55.95A124.35,124.35,0,0,1,203.25,253.83Zm15-117.86c-14.31,0-33.15,3.62-52.34,17.67-14.25,10.43-21.69,23.76-22.1,39.62-.53,20.44,10.91,38.43,17.16,43.51l.59.49c10.95,8.94,26,21.18,66.74,12.7,35.15-7.31,53-25.8,53-55,0-26.88-12.69-45.36-37.71-54.93h0C243.32,140,233.27,136,218.21,136Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.496px 194.402px"
    },
    id: "elkrjn1lsiq09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.94,201.67c1.61,3,12.82,9.17,17.6,13.06A53,53,0,0,0,281.26,203C273.29,201.37,259.43,198.9,260.94,201.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "271.043px 207.575px"
    },
    id: "el0x0fj2r02gv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,219.28c-1,2.76,7.14,7.86,11.63,11.07a45.32,45.32,0,0,0,8-12.06C270.82,218.28,258.49,216.33,257.42,219.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "267.193px 223.999px"
    },
    id: "elw0vjvutoz1h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.9,233.71c.13,1.39,1.75,3.59,3.77,5.85a56.56,56.56,0,0,0,8.8-6.64C261.09,232.26,253.67,231.18,253.9,233.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.182px 235.838px"
    },
    id: "elm5tlak4rb3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.74,245.36a51.92,51.92,0,0,0,11.93,5.31c-.59-2.47-1.3-5.39-1.95-7.8C180.81,239.43,175.58,242.84,171.74,245.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "177.705px 246.042px"
    },
    id: "elijd03kjv8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.33,235a21.44,21.44,0,0,0,2.28,2.18c2.22,1.81,4.58,3.76,7.27,5.67.7-4.25,2-10.33,1.52-13.69C168.89,225.28,162.18,231.93,158.33,235Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "163.917px 235.414px"
    },
    id: "elf0jp82pax9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.36,232.65c1.53-4.49,5-11.83,6-16.19,1.1-4.68-7.92,3.14-11.91,6.76A58.88,58.88,0,0,0,156.36,232.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "156.451px 223.829px"
    },
    id: "el0xn9d9w1w3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwcd1ae3pv1f"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.49,
    cy: 183.02,
    rx: 16.91,
    ry: 9.92,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "247.49px 183.02px",
      transform: "rotate(-5.34deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elza84y1fdce"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.3,
    cy: 193.7,
    rx: 16.91,
    ry: 9.92,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "177.3px 193.7px",
      transform: "rotate(-5.34deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,155.72s-21.08-16.12-23.56-7.85,8.26,25.63,8.26,25.63",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "154.844px 159.505px"
    },
    id: "elwzc6rau3l4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.51,174a.5.5,0,0,1-.42-.24c-.44-.72-10.84-17.65-8.32-26a3.5,3.5,0,0,1,2.35-2.48c6.11-2,21.35,9.59,22,10.08a.5.5,0,0,1-.6.8c-.16-.12-15.46-11.74-21.09-9.93a2.51,2.51,0,0,0-1.69,1.82c-2.39,8,8.1,25.05,8.21,25.22a.51.51,0,0,1-.16.69A.53.53,0,0,1,151.51,174Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "154.848px 159.526px"
    },
    id: "elsm0ide9t2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.46,142.49s15.71-15.71,21.92-11.57.41,26,.41,26",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "254.855px 143.573px"
    },
    id: "eloiqj8fbncij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.79,157.46a.3.3,0,0,1-.13,0,.48.48,0,0,1-.35-.61c.05-.21,5.62-21.61-.21-25.5S243,142.69,242.82,142.85a.5.5,0,1,1-.71-.71c.65-.66,16.08-15.95,22.54-11.64s.86,25.68.62,26.59A.5.5,0,0,1,264.79,157.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.857px 143.601px"
    },
    id: "elxke5g9878ih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.08,170.59s-9.67-15.58-7.53-20.15,18.54,9.67,18.54,9.67",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "154.665px 160.063px"
    },
    id: "elthk7tth4woi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.08,171.09a.52.52,0,0,1-.43-.24c-.4-.64-9.79-15.87-7.55-20.62a2,2,0,0,1,1.45-1.13c4.4-.93,16.5,9.45,17.87,10.63a.5.5,0,0,1-.66.76c-3.6-3.13-13.69-11.11-17-10.41a1,1,0,0,0-.75.57c-1.67,3.55,4.84,15.41,7.49,19.68a.49.49,0,0,1-.16.68A.5.5,0,0,1,153.08,171.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "154.674px 160.066px"
    },
    id: "ely4454q59c5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,144.26S260,133,264,133.51s-1.34,21.23-1.34,21.23",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "255.243px 144.117px"
    },
    id: "elycyth7z9e0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.69,155.24l-.12,0a.5.5,0,0,1-.36-.61c1.23-4.74,4-17.61,2.26-20.25a.71.71,0,0,0-.5-.35c-3.14-.43-14.57,7.55-18.71,10.65a.5.5,0,0,1-.6-.8c1.56-1.17,15.33-11.38,19.44-10.84a1.7,1.7,0,0,1,1.2.78c2.34,3.49-1.66,19.28-2.13,21.06A.49.49,0,0,1,262.69,155.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "255.246px 144.13px"
    },
    id: "elqgna98yqye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.17,180.29c-5.06.42-12.85,2.19-12.85,3.46,0,2.15,7.79,7,10.74,5.38s7.25-7.78,6.18-8.6C219.76,180.16,218.18,180.12,216.17,180.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.864px 184.824px"
    },
    id: "elu208bmajph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.59,190a12.56,12.56,0,0,1-5.75-1.95c-2-1.15-4-2.87-4-4.25,0-2.16,10.37-3.71,13.31-4h0c3.58-.3,4.21.19,4.42.34a1,1,0,0,1,.35,1c-.15,1.93-3.86,7-6.6,8.47A3.62,3.62,0,0,1,212.59,190Zm3.62-9.16h0c-5.5.46-12,2.17-12.4,3,0,.58,1.33,2,3.54,3.33,2.67,1.58,5.27,2.2,6.47,1.55,2.84-1.55,6.4-7,6.08-7.81,0,0-.29-.19-1.71-.19C217.69,180.69,217,180.72,216.21,180.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.892px 184.853px"
    },
    id: "eleteo3ic5ktb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.38,177.57c5.4,0,10.1,1.89,12.58,4.67-1-4.32-6-7.62-12.05-7.62-5.38,0-9.93,2.6-11.57,6.21A18.66,18.66,0,0,1,184.38,177.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "185.15px 178.43px"
    },
    id: "el06bekxz8ad45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57,169.91c-5.28,1.15-9.47,4-11.29,7.24,0-4.43,4.22-8.72,10.14-10,5.25-1.15,10.26.42,12.63,3.59A18.69,18.69,0,0,0,237.57,169.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.665px 171.962px"
    },
    id: "el8a6qqecy7nl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.18,200.1a15.25,15.25,0,0,1-13.5-8.12.5.5,0,0,1,.21-.68.49.49,0,0,1,.67.21,14.29,14.29,0,0,0,26.61-3.8.49.49,0,0,1,.59-.39.5.5,0,0,1,.39.59A15.33,15.33,0,0,1,212.18,200.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.89px 193.704px"
    },
    id: "el2ci15g194g9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.46,199.86a.49.49,0,0,1-.49-.42l-1.52-10a.5.5,0,1,1,1-.15l1.53,10a.51.51,0,0,1-.42.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "213.714px 194.36px"
    },
    id: "el0zm7hwzhddfl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.53,195.6a.5.5,0,0,1-.3-.9c9-6.73,21.93-3.48,22.48-3.33a.5.5,0,1,1-.25,1c-.13,0-13-3.27-21.63,3.17A.47.47,0,0,1,157.53,195.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "168.566px 193.03px"
    },
    id: "el3fdrkavqhcw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,209.53a.53.53,0,0,1-.31-.11.51.51,0,0,1-.09-.7,30,30,0,0,1,21.24-11.41h0a.5.5,0,0,1,0,1,29,29,0,0,0-20.46,11A.51.51,0,0,1,161,209.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "171.42px 203.42px"
    },
    id: "elr3c99a6ztj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.82,215.52l-.18,0a.5.5,0,0,1-.28-.65,26.66,26.66,0,0,1,12.32-13.66.5.5,0,0,1,.42.9,26.22,26.22,0,0,0-11.81,13.13A.51.51,0,0,1,171.82,215.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "177.831px 208.352px"
    },
    id: "el4tx30njye43",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,179.81a.49.49,0,0,1-.41-.21.51.51,0,0,1,.11-.7c.46-.32,11.35-8,22.19-4.93a.5.5,0,1,1-.28,1c-10.36-2.92-21.22,4.71-21.32,4.79A.52.52,0,0,1,246.4,179.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "257.284px 176.53px"
    },
    id: "el91feewri7ih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.89,189.2a.5.5,0,0,1-.26-.08,29,29,0,0,0-23.06-3,.5.5,0,0,1-.64-.3.51.51,0,0,1,.31-.64,30,30,0,0,1,23.91,3.05.51.51,0,0,1,.17.69A.52.52,0,0,1,269.89,189.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "258.147px 186.578px"
    },
    id: "elgbiaqc096gd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.94,198.67a.52.52,0,0,1-.37-.16,26.24,26.24,0,0,0-15.73-8,.5.5,0,0,1-.46-.53.52.52,0,0,1,.53-.47,26.75,26.75,0,0,1,16.39,8.35.49.49,0,0,1,0,.7A.51.51,0,0,1,261.94,198.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "253.913px 194.091px"
    },
    id: "el2v70d0u4nk5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.05,153.59s22.77-17.17,53.75-9.34C231.8,144.25,196.34,145.75,178.05,153.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "204.925px 147.897px"
    },
    id: "elhjygklo6tl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.14,159.56s16.05-12.32,42.55-7.09C227.69,152.47,197.46,154.71,185.14,159.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "206.415px 155.368px"
    },
    id: "el6i9a9yuxocp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.75,157.32s-16.43,1.49-16.43,3.36,6.72,3.36,9.34,2.24S215.75,157.32,215.75,157.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "207.535px 160.313px"
    },
    id: "el1c284i7ee0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.35,253.32a87.25,87.25,0,0,1-41.9-10.46c-18.68-10.19-31.37-26.48-35.75-45.88s.07-39.56,12.55-56.79,31.44-29.42,53.43-34.39,44.38-2.1,63,8.08,31.37,26.48,35.75,45.88-.07,39.56-12.55,56.79S250.47,246,228.47,250.94A95.93,95.93,0,0,1,207.35,253.32Zm9.46-148.9a95.29,95.29,0,0,0-20.91,2.35c-21.75,4.92-40.52,17-52.84,34s-16.71,36.88-12.39,56,16.84,35.17,35.25,45.22,40.58,12.9,62.33,8,40.53-17,52.85-34,16.7-36.87,12.39-56-16.84-35.17-35.26-45.22A86.25,86.25,0,0,0,216.81,104.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.065px 178.371px"
    },
    id: "el65b2wglb0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,349.94s29.87,28.37,50.4,25.38A36.17,36.17,0,0,0,318,355.17s-2.61,12.31,3.73,14.55,13.44-8.21,11.2-25.38-14.56-19-14.56-19,18.29,4.48-27.62,16.05S240,349.94,240,349.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "286.676px 350.44px"
    },
    id: "elk036ibaodk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.23,376.05c-20.22,0-46.4-24.64-47.56-25.75a.5.5,0,0,1,.58-.8c.28.13,6.22,2.51,50.41-8.63,26.84-6.77,30.85-10.86,30.84-12.7,0-1.3-2.32-2.16-3.22-2.38a.5.5,0,0,1,.2-1c.13,0,12.72,2.12,15,19.47,1.73,13.31-2,21.58-5.79,24.62a6.17,6.17,0,0,1-6.07,1.3c-4.74-1.68-4.85-8.32-4.48-12.23a37,37,0,0,1-26.64,17.85A23.24,23.24,0,0,1,287.23,376.05ZM241.6,350.72c5.86,5.24,31,26.69,48.73,24.11A36,36,0,0,0,317.57,355a.5.5,0,0,1,.95.3c0,.12-2.45,11.91,3.41,14a5.16,5.16,0,0,0,5.11-1.12c3.84-3.11,7-11.65,5.43-23.73-1.37-10.49-6.49-15.13-10.17-17.13a2.2,2.2,0,0,1,.2.9c0,3.83-10.32,8.31-31.6,13.67C257.26,350.32,245.52,351,241.6,350.72Zm-1.59-.78h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "286.719px 350.415px"
    },
    id: "elmggf6spwnmp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,325.3s14.41,3.53-14.46,12.42c4.57,7.58,8.5,19.49.55,32.53A36,36,0,0,0,318,355.17s-2.61,12.31,3.73,14.55,13.44-8.21,11.2-25.38S318.4,325.3,318.4,325.3Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "318.646px 347.775px"
    },
    id: "el6uxayoo0lf4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.49,370.75a.5.5,0,0,1-.42-.76c7.78-12.77,4-24.46-.55-32a.47.47,0,0,1,0-.43.46.46,0,0,1,.32-.3c15.49-4.77,17.74-7.75,17.7-9.1s-2.33-2.14-3.22-2.35a.5.5,0,0,1,.2-1c.13,0,12.72,2.12,15,19.47,1.73,13.31-2,21.58-5.79,24.62a6.17,6.17,0,0,1-6.07,1.3c-4.72-1.67-4.85-8.25-4.49-12.17a37.32,37.32,0,0,1-12.35,12.64A.53.53,0,0,1,304.49,370.75ZM318,354.67a.39.39,0,0,1,.15,0,.51.51,0,0,1,.34.58c0,.12-2.45,11.91,3.41,14a5.14,5.14,0,0,0,5.11-1.13c3.84-3.1,7-11.64,5.43-23.72-1.37-10.5-6.49-15.13-10.18-17.14a2.17,2.17,0,0,1,.21.85c.08,2.9-5.74,6.14-17.8,9.9,4.32,7.43,7.74,18.49,1.27,30.66a35.69,35.69,0,0,0,11.6-13.7A.49.49,0,0,1,318,354.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.712px 347.776px"
    },
    id: "eln0ygbir9ku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,355.67a.5.5,0,0,1-.26-.08.5.5,0,0,1-.17-.69,28.36,28.36,0,0,0,3.29-12.45.49.49,0,0,1,.52-.48.51.51,0,0,1,.48.53,29.17,29.17,0,0,1-3.43,12.93A.52.52,0,0,1,318,355.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "319.678px 348.82px"
    },
    id: "eleuncwo0a7lb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.34,266s-17.92-6-27.25,8.21,1.49,36.21,9,37.33,10.82-17.17,10.82-17.17,15.31,13.44,26.13,9.33",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "162.258px 288.166px"
    },
    id: "elmak9zucwfm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.71,312A4.71,4.71,0,0,1,150,312c-3.3-.49-7.18-4.71-9.88-10.75-3.4-7.62-5-18.81.58-27.34,9.44-14.35,27.65-8.48,27.83-8.42a.5.5,0,0,1,.31.64.49.49,0,0,1-.63.31c-.17-.05-17.66-5.68-26.67,8-5.4,8.19-3.8,19-.5,26.38,2.52,5.65,6.18,9.74,9.11,10.18,6.92,1,10.23-16.59,10.26-16.77a.51.51,0,0,1,.33-.38.48.48,0,0,1,.49.09c.16.14,15.2,13.2,25.63,9.24a.51.51,0,0,1,.64.29.5.5,0,0,1-.29.65c-9.83,3.72-22.89-6.32-26-8.87C160.45,298.79,157.2,312,150.71,312Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.283px 288.132px"
    },
    id: "eldo8y1tycfip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.56,264.72c-6-.19-14.13,1.33-19.47,9.44-9.33,14.19,1.49,36.21,9,37.33s10.82-17.17,10.82-17.17a55.09,55.09,0,0,0,5.33,4C171.56,280.88,164.8,269.65,160.56,264.72Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "152.836px 288.122px"
    },
    id: "elwtux6a8561h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.71,312A4.71,4.71,0,0,1,150,312c-3.3-.49-7.18-4.71-9.88-10.75-3.4-7.62-5-18.81.58-27.34,5.48-8.33,13.84-9.87,19.9-9.67a.52.52,0,0,1,.37.17c4.46,5.19,11.14,16.52,5.74,34.05a.52.52,0,0,1-.31.32.48.48,0,0,1-.45-.05,57.52,57.52,0,0,1-4.72-3.47C160.45,298.78,157.2,312,150.71,312Zm8.93-46.84c-5.71,0-13.17,1.7-18.13,9.24-5.4,8.19-3.8,19-.5,26.38,2.52,5.65,6.18,9.74,9.11,10.18,6.92,1,10.23-16.59,10.26-16.77a.49.49,0,0,1,.33-.38.48.48,0,0,1,.49.09,52.58,52.58,0,0,0,4.71,3.56c4.85-16.52-1.32-27.24-5.59-32.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "152.878px 288.119px"
    },
    id: "elc80kcv6oare",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.81,250.19s40.45-15.46,40.45-47.16-23.6-53.34-15.17-90.45,48-54.11,78.36-34.79,19.38,41-1.68,68.81S401.29,179.07,392.86,210s-35.39,46.39-62.36,50.25C330.5,260.24,319.55,249.42,312.81,250.19Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "373.994px 164.998px"
    },
    id: "el14ao1o3grpkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.51,260.74a.52.52,0,0,1-.36-.14c-.1-.11-10.88-10.65-17.28-9.91a.5.5,0,0,1-.24-1c.4-.15,40.13-15.7,40.13-46.69,0-13.22-4.05-24.45-8.34-36.33-5.77-16-11.74-32.56-6.82-54.23C341.75,94.2,353.55,79.84,370,73.09a50.32,50.32,0,0,1,46.74,4.28c10.94,7,17,14.53,18.55,23.12,2.4,13.31-6.31,28.18-20.1,46.41-14.13,18.66-15.32,27-17.13,39.59a176.36,176.36,0,0,1-4.7,23.63c-7.39,27.12-30.85,46-62.76,50.62Zm-15.49-11c6.33,1.12,14.32,8.63,15.66,9.92,31.38-4.58,54.44-23.2,61.7-49.85a178.61,178.61,0,0,0,4.67-23.51c1.83-12.76,3-21.19,17.32-40,13.64-18,22.25-32.68,19.92-45.63-1.49-8.3-7.41-15.64-18.11-22.46A49.35,49.35,0,0,0,370.36,74c-16.12,6.63-27.71,20.73-31.78,38.68-4.86,21.38,1.06,37.8,6.78,53.67,4.13,11.44,8.4,23.27,8.4,36.67C353.76,230.56,323.27,246.09,315,249.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "373.962px 164.989px"
    },
    id: "elyhgdsqq90of",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.64,141.39c18.42-25.35,26.23-45.49-2.19-63.6-21.9-14-48.63-9-65,8.86C371.54,86.13,404.75,93.16,418.64,141.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "393.311px 105.552px"
    },
    id: "elc0eckw1ia3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.74,110.56c8.61-1.09,27.83-.27,47.61,22.4a.93.93,0,0,0,1.57-1c-3.38-8.45-11.69-25.1-26.06-29.21-12.52-3.58-20.44,1-24.51,4.82A1.71,1.71,0,0,0,346.74,110.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.405px 117.421px"
    },
    id: "elqvvf6wl5gr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.37,133.22c8.61-1.09,27.82-.26,47.6,22.4a.93.93,0,0,0,1.57-.94c-3.37-8.46-11.68-25.11-26.05-29.21-12.52-3.58-20.45,1-24.51,4.82A1.7,1.7,0,0,0,342.37,133.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "366.018px 140.056px"
    },
    id: "elnpu24kqugcc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,157.87c5.17-1.31,16.94-2.2,30.69,10.51a.57.57,0,0,0,.88-.7c-2.68-5-9-14.83-18.06-16.34-7.89-1.32-12.37,2.15-14.57,4.79A1.07,1.07,0,0,0,348,157.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "363.161px 159.788px"
    },
    id: "elubuhc06bmq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.77,179.39c4.55-1.19,14.92-1.95,27.13,10a.51.51,0,0,0,.77-.65c-2.4-4.72-8-13.9-16-15.38-7-1.28-10.9,1.93-12.82,4.39A1,1,0,0,0,351.77,179.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "365.175px 181.292px"
    },
    id: "el5qgw9qtl9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.67,212.61c-2.4-4.72-8-13.9-16-15.38-4.87-.89-8.25.4-10.5,2.1.07,1.19.11,2.38.11,3.59,5.1-.89,14.63-.45,25.65,10.34A.51.51,0,0,0,379.67,212.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "366.446px 205.143px"
    },
    id: "elo83a0wppt7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65,248.66a.51.51,0,0,0,.78-.65c-2.22-4.36-7.18-12.49-14.21-14.89a71.22,71.22,0,0,1-5.8,5.08C338.57,238.85,345.28,241.43,352.65,248.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "343.469px 240.964px"
    },
    id: "el953o0fdkraa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.07,216.72a13.93,13.93,0,0,0-7.7.55,41.61,41.61,0,0,1-2.59,5.12c5.12-.87,14.6-.37,25.55,10.36.42.42,1.05-.11.78-.65C371.7,227.38,366.08,218.19,358.07,216.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.978px 224.659px"
    },
    id: "elkspvx8200vd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.1,251.16s1.77,46.32,38.72,80.49c31.25,28.9,78,36.21,118.7.74,0,0,20.91,13.44,42.93,7.47S374.77,304,374.77,304s27.81,15.26,24.37-2.29C394.5,278.1,364,263.34,358,264.46s-6.72,7.46-6.72,7.46-13.81-19-29.11-26.13S290.89,237.38,281.5,227l-3.79-1a93,93,0,0,1-26.87,20.53c-16.05,7.84-41.06,10.82-52.64,9.7s-35.46-9.33-35.46-9.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "280.767px 291.126px"
    },
    id: "elyesr7tmms3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.47,356.75c-1.29,0-2.57,0-3.86-.09-20.07-1-40-9.73-56.13-24.65-36.68-33.91-38.87-80.37-38.88-80.84v-.09l.65-4.25a.49.49,0,0,1,.23-.35.52.52,0,0,1,.42,0c.24.08,24,8.2,35.35,9.3,11.12,1.08,36.16-1.74,52.37-9.65a93.14,93.14,0,0,0,26.71-20.41.5.5,0,0,1,.51-.16l3.8,1a.61.61,0,0,1,.24.15c6,6.65,15,9.58,24.48,12.69a141.2,141.2,0,0,1,16,6c13.36,6.19,25.7,21.57,28.65,25.41.54-2,2.2-5.91,6.88-6.79,6.27-1.18,37.11,14,41.75,37.68.73,3.76.12,6.4-1.83,7.83-5.21,3.8-18.36-2.47-22.21-4.45,1.08,3.91,4,16.82-1.07,26.23a18.41,18.41,0,0,1-11.94,9.09c-20.5,5.56-40.26-5.68-43-7.33C301.59,348.59,281.24,356.75,260.47,356.75ZM162.6,251.18c.08,1.7,2.7,46.95,38.56,80.1,26.61,24.61,73.49,39.56,118,.74a.48.48,0,0,1,.59,0c.21.14,21,13.25,42.53,7.41a17.43,17.43,0,0,0,11.32-8.6c5.74-10.61.71-26.44.66-26.6a.48.48,0,0,1,.15-.54.5.5,0,0,1,.56-.05c.17.09,16.7,9.08,22.2,5.07,1.61-1.18,2.09-3.48,1.43-6.83-4.53-23.12-34.44-38-40.58-36.88-5.53,1-6.28,6.79-6.31,7a.5.5,0,0,1-.37.42.48.48,0,0,1-.53-.19c-.14-.18-13.92-19-28.92-26a142.83,142.83,0,0,0-15.88-5.91c-9.57-3.13-18.61-6.09-24.82-12.86l-3.35-.9A94.63,94.63,0,0,1,251.06,247c-16.37,8-41.67,10.83-52.91,9.75-10.5-1-31.3-7.92-35-9.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.769px 291.147px"
    },
    id: "elsb7oqz4lbnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.85,273.59c8.72,1.93,28.9,5.3,51.38,1.64a3.28,3.28,0,0,1,3.63,2.27,68,68,0,0,0,17.36,28.2,3.26,3.26,0,0,1-1.52,5.53c-10.76,2.55-34.66,6.25-60.39-2.67a3.28,3.28,0,0,1-1.63-1.26c-2.3-3.38-10.26-15.86-12.77-30A3.27,3.27,0,0,1,178.85,273.59Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "213.547px 293.858px"
    },
    id: "elc2o41tlbxd6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.73,314.73a105.42,105.42,0,0,1-34.58-5.7,3.82,3.82,0,0,1-1.89-1.45c-2.37-3.5-10.32-16-12.84-30.16a3.76,3.76,0,0,1,4.54-4.31h0c7.81,1.72,28.44,5.33,51.19,1.63a3.75,3.75,0,0,1,4.18,2.61,67.94,67.94,0,0,0,17.23,28,3.77,3.77,0,0,1-1.74,6.39A114.36,114.36,0,0,1,223.73,314.73ZM178.14,274a2.79,2.79,0,0,0-1.93.77,2.69,2.69,0,0,0-.81,2.45c2.49,14,10.34,26.32,12.69,29.78a2.71,2.71,0,0,0,1.39,1.06c25.2,8.74,48.48,5.42,60.11,2.67a2.77,2.77,0,0,0,1.28-4.69,68.87,68.87,0,0,1-17.49-28.41,2.78,2.78,0,0,0-3.07-1.93,141.06,141.06,0,0,1-51.57-1.64A3.05,3.05,0,0,0,178.14,274Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "213.543px 293.873px"
    },
    id: "elgdtdxkkfyo6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbobvwbnjwan"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.37,
    cy: 292.17,
    rx: 6.78,
    ry: 9.52,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "190.37px 292.17px",
      transform: "rotate(-17.17deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.71,302a7.07,7.07,0,0,1-4.24-1.57A12.89,12.89,0,0,1,183.33,287a6.44,6.44,0,0,1,4.08-4.4c3.84-1.19,8.29,2.14,9.92,7.42h0c1.63,5.28-.17,10.54-4,11.72A5.27,5.27,0,0,1,191.71,302ZM189,283.36a4.58,4.58,0,0,0-1.32.19,5.5,5.5,0,0,0-3.43,3.76,11.89,11.89,0,0,0,3.8,12.31,5.48,5.48,0,0,0,4.95,1.17c3.31-1,4.81-5.72,3.34-10.47C195.1,286.19,192,283.36,189,283.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "190.384px 292.179px"
    },
    id: "elyu74uya7w69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.41,291.6c1.55,5-.09,10-3.67,11.09s-7.74-2.07-9.29-7.09.1-10,3.67-11.1S213.86,286.57,215.41,291.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "208.931px 293.594px"
    },
    id: "el7ueawiqglbv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.27,303.42a7,7,0,0,1-4.24-1.58,12.91,12.91,0,0,1-4.14-13.41A6.43,6.43,0,0,1,206,284c3.83-1.19,8.28,2.14,9.91,7.42h0c1.63,5.28-.16,10.54-4,11.72A5.59,5.59,0,0,1,210.27,303.42Zm-2.68-18.64a4.65,4.65,0,0,0-1.32.2,5.48,5.48,0,0,0-3.43,3.76,11.91,11.91,0,0,0,3.8,12.31,5.49,5.49,0,0,0,5,1.17c3.3-1,4.8-5.72,3.34-10.47C213.66,287.62,210.56,284.78,207.59,284.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.958px 293.589px"
    },
    id: "elvpc1jorauvf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu9muy99wki"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.69,
    cy: 295.03,
    rx: 6.78,
    ry: 9.52,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "228.69px 295.03px",
      transform: "rotate(-17.17deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230,304.84a7,7,0,0,1-4.23-1.57,12.9,12.9,0,0,1-4.15-13.42,6,6,0,0,1,9.94-3.07,12.18,12.18,0,0,1,4.06,6.1h0a12.21,12.21,0,0,1,.09,7.32,6.45,6.45,0,0,1-4.09,4.4A5.58,5.58,0,0,1,230,304.84Zm-2.67-18.63a4.61,4.61,0,0,0-1.33.2,5.48,5.48,0,0,0-3.43,3.76,11.91,11.91,0,0,0,3.8,12.31,5,5,0,0,0,8.39-2.59,11.19,11.19,0,0,0-.09-6.72h0a11.18,11.18,0,0,0-3.71-5.59A6.05,6.05,0,0,0,227.35,286.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "228.68px 295.006px"
    },
    id: "elh37d4h4tdz9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.07,327.7a.51.51,0,0,1-.28-.09,21.66,21.66,0,0,1-3.7-3.09.5.5,0,1,1,.74-.67,21,21,0,0,0,3.53,2.94.5.5,0,0,1,.13.69A.52.52,0,0,1,310.07,327.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "308.258px 325.682px"
    },
    id: "elrlq9g29uzkl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.52,332.89a.51.51,0,0,1-.2,0s-2.72-1.2-5.75-2.91a.49.49,0,0,1-.19-.68.5.5,0,0,1,.68-.19c3,1.68,5.64,2.85,5.66,2.87a.49.49,0,0,1-.2.95Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "316.678px 330.989px"
    },
    id: "el0063lgca9ibd7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,260.72s-29.86-7.09-40.69,7.84-.75,34.34,10.83,37.7,14.18-13.81,14.18-13.81,13.07,6.72,25,3.73,13.44-24.26,6.35-31.72",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "255.309px 282.867px"
    },
    id: "eljvgj2b04bx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,307.2a10.56,10.56,0,0,1-3-.46c-6.12-1.77-11.75-7.8-14.34-15.36a24.86,24.86,0,0,1,3.25-23.11c10.89-15,40-8.33,41.2-8a.5.5,0,1,1-.23,1c-.29-.07-29.66-6.84-40.17,7.65a23.88,23.88,0,0,0-3.1,22.2c2.49,7.26,7.85,13,13.66,14.72a8.08,8.08,0,0,0,6.86-.78c5.22-3.34,6.68-12.53,6.7-12.62a.48.48,0,0,1,.26-.37.47.47,0,0,1,.46,0c.13.06,13,6.59,24.66,3.69,4.3-1.08,7.57-4.76,9.2-10.39,2.19-7.53.86-16.35-3.1-20.51a.5.5,0,0,1,.73-.69c4.18,4.4,5.62,13.64,3.34,21.48-1.74,6-5.27,9.91-9.93,11.08-10.52,2.63-22-2.22-24.75-3.48-.44,2.25-2.21,9.57-7,12.65A8.44,8.44,0,0,1,241,307.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "255.31px 282.856px"
    },
    id: "elxbdl8nngda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.71,221.9l-.22-.58a90.59,90.59,0,0,1-49.13,29.13c-24.72,5.59-49,.93-67.5-10.91l1.24,11.62c18.3,11.26,42.1,15.58,66.26,10.12C251,256.16,269.64,243.44,281.5,227Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "221.18px 242.476px"
    },
    id: "elp2n9l7qj21s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.55,264.1a87.33,87.33,0,0,1-45.72-12.52.51.51,0,0,1-.23-.37l-1.24-11.62a.51.51,0,0,1,.24-.48.49.49,0,0,1,.53,0c19.05,12.22,43.52,16.18,67.12,10.84,19.3-4.36,36.65-14.64,48.86-29a.49.49,0,0,1,.46-.17.5.5,0,0,1,.38.31l.21.52,3.75,5.07a.5.5,0,0,1,0,.59c-12.46,17.24-31.44,29.47-53.44,34.44A94.82,94.82,0,0,1,207.55,264.1Zm-45-13.24c18.8,11.49,42.73,15.12,65.68,9.93,21.64-4.89,40.31-16.87,52.64-33.76l-3.54-4.78c-12.31,14.17-29.64,24.34-48.88,28.69-23.5,5.31-47.86,1.51-67-10.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.182px 242.438px"
    },
    id: "elqivcxsuzhy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.69,295.25c7.46-22.58-4.32-32.2-12.38-36-7.61.67-15.46,3.06-20,9.3-10.83,14.93-.75,34.34,10.83,37.7s14.18-13.81,14.18-13.81A45.62,45.62,0,0,0,259.69,295.25Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "242.375px 282.968px"
    },
    id: "el9gmjrhy6x7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,307.2a10.56,10.56,0,0,1-3-.46c-6.12-1.77-11.75-7.8-14.34-15.36a24.86,24.86,0,0,1,3.25-23.11c4-5.47,10.81-8.67,20.35-9.51a.58.58,0,0,1,.26.05c8,3.76,20.26,13.52,12.63,36.59a.5.5,0,0,1-.61.33,47.2,47.2,0,0,1-6.84-2.54c-.45,2.26-2.22,9.57-7,12.65A8.44,8.44,0,0,1,241,307.2Zm6.19-47.43c-9.17.83-15.73,3.89-19.5,9.09a23.88,23.88,0,0,0-3.1,22.2c2.49,7.26,7.85,13,13.66,14.72a8.08,8.08,0,0,0,6.86-.78c5.22-3.34,6.68-12.53,6.7-12.62a.48.48,0,0,1,.26-.37.47.47,0,0,1,.46,0,45.48,45.48,0,0,0,6.8,2.62C266.4,272.74,254.86,263.41,247.22,259.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "242.359px 282.98px"
    },
    id: "el2doc7zt8f7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,264.45c-6,1.12-6.72,7.47-6.72,7.47S369,284.64,374.77,304c0,0,27.81,15.26,24.37-2.29C394.5,278.1,364,263.34,358,264.45Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "375.357px 287.271px"
    },
    id: "el9gm2aokxtch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.28,310.67c-7.34,0-18.18-5.9-18.75-6.21a.53.53,0,0,1-.24-.29c-5.66-19-23.15-31.72-23.33-31.84a.51.51,0,0,1-.2-.47c0-.07.86-6.72,7.12-7.9s37.11,14,41.75,37.68c.73,3.76.12,6.4-1.83,7.83A7.63,7.63,0,0,1,393.28,310.67Zm-18.09-7c1.81,1,16.83,8.77,22,5,1.61-1.18,2.09-3.48,1.43-6.83-4.53-23.12-34.44-38-40.58-36.88-4.9.92-6.05,5.54-6.27,6.75C354,273.34,369.74,285.72,375.19,303.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.342px 287.288px"
    },
    id: "el92798eoyjuw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,250.46c-11.88,47.45-65.13,79.51-126,73.31q-6.31-.64-12.43-1.8a116,116,0,0,0,8.43,8.86c.93.12,1.86.24,2.79.34,64,7.2,116.11-22.71,135.89-73.46A81.15,81.15,0,0,0,330,250.46Z",
    style: {
      fill: "rgb(96, 116, 203)",
      transformOrigin: "265.125px 291.347px"
    },
    id: "elesiuvyywbu7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.39,332.74a167.53,167.53,0,0,1-18.7-1.07c-.94-.1-1.87-.23-2.81-.35a.52.52,0,0,1-.28-.13,117,117,0,0,1-8.46-8.89.5.5,0,0,1,.47-.82c4.09.77,8.26,1.37,12.39,1.79,59.6,6.06,113.54-25.29,125.47-72.93a.49.49,0,0,1,.32-.35.48.48,0,0,1,.46.06,83,83,0,0,1,8.73,7.29.53.53,0,0,1,.12.55,113.24,113.24,0,0,1-51.59,58.72C268.14,327.26,245.56,332.73,221.39,332.74Zm-21.22-2.39c.88.12,1.75.23,2.63.33,62.06,7,115.1-21.61,135.24-72.84a82.74,82.74,0,0,0-7.78-6.55c-6,22.93-21.8,42.92-44.68,56.37-23.3,13.7-52.31,19.6-81.68,16.61-3.69-.38-7.41-.9-11.07-1.55C195.17,325.39,197.64,328,200.17,330.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "265.074px 291.348px"
    },
    id: "elmrnof98ka7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.82,325a146.74,146.74,0,0,1-14.92-.76c-4.17-.43-8.37-1-12.49-1.81a.56.56,0,0,1-.29-.16c-27.73-32.37-29.51-70.74-29.52-71.13l.65-4.33a.49.49,0,0,1,.23-.36.52.52,0,0,1,.42,0c.24.08,24,8.2,35.35,9.3,11.12,1.08,36.17-1.74,52.37-9.65a93.14,93.14,0,0,0,26.71-20.41.5.5,0,0,1,.51-.16l3.8,1a.61.61,0,0,1,.24.15c6,6.65,15,9.58,24.48,12.69a141.2,141.2,0,0,1,16,6,48.84,48.84,0,0,1,7.9,4.7.5.5,0,0,1,.2.53c-5.82,23.22-21.75,43.5-44.86,57.09C266.24,319,243,325,218.82,325Zm-27-3.52c4,.76,8.15,1.35,12.23,1.76,59.47,6.05,113.3-25.15,125.39-72.61a48.42,48.42,0,0,0-7.46-4.42,142.83,142.83,0,0,0-15.88-5.91c-9.57-3.13-18.61-6.09-24.82-12.86l-3.35-.9A94.63,94.63,0,0,1,251.06,247c-16.37,8-41.67,10.83-52.91,9.75-10.5-1-31.3-7.92-35-9.16l-.56,3.65C162.61,251.52,164.38,289.45,191.77,321.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "246.037px 275.257px"
    },
    id: "elu8fstrpqrhq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "saiki--Yarn--inject-2",
    className: "animable animator-active",
    style: {
      transformOrigin: "108.77px 388px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "ely645ebb3wlq"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108.77,
    cy: 388,
    r: 58.71,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "108.77px 388px",
      transform: "rotate(-20.23deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.77,447.2A59.21,59.21,0,1,1,168,388,59.27,59.27,0,0,1,108.77,447.2Zm0-117.41A58.21,58.21,0,1,0,167,388,58.27,58.27,0,0,0,108.77,329.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.79px 387.99px"
    },
    id: "eliblbvjfo60l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.72,361.08a.51.51,0,0,1-.48-.35c-.43-1.33-.91-2.66-1.43-4a.49.49,0,0,1,.27-.65.5.5,0,0,1,.65.28c.54,1.31,1,2.67,1.47,4a.5.5,0,0,1-.33.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "156.997px 358.562px"
    },
    id: "elajvliw1qiq5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.86,436.38a.51.51,0,0,1-.49-.39.5.5,0,0,1,.38-.6,58.29,58.29,0,0,0,43.72-70.26.51.51,0,0,1,.38-.6.5.5,0,0,1,.6.37A59.24,59.24,0,0,1,115,436.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.707px 400.448px"
    },
    id: "elyiupk75jpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.83,437.83a59.09,59.09,0,0,1-17.6-2.67.49.49,0,0,1-.33-.62.5.5,0,0,1,.63-.33,58,58,0,0,0,17.3,2.62,58.87,58.87,0,0,0,9.21-.73.5.5,0,0,1,.57.42.49.49,0,0,1-.41.57A59.8,59.8,0,0,1,101.83,437.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.7471px 436.008px"
    },
    id: "elpok6gnr2tfh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.72,432.93a59.25,59.25,0,0,1-12.21-1.26.49.49,0,0,1-.39-.59.49.49,0,0,1,.59-.39,58.23,58.23,0,0,0,65.64-79.62.51.51,0,0,1,.27-.66.5.5,0,0,1,.65.27,59.22,59.22,0,0,1-54.55,82.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "119.019px 391.652px"
    },
    id: "el3lwkctbvu2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.84,399.26a.48.48,0,0,1-.26-.07.5.5,0,0,1-.17-.69,58.35,58.35,0,0,0,3.8-52.71.5.5,0,1,1,.92-.38A59.31,59.31,0,0,1,138.26,399,.47.47,0,0,1,137.84,399.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.051px 372.158px"
    },
    id: "elu2fpiv0w5qf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.56,427.63a59.68,59.68,0,0,1-6.56-.36.49.49,0,0,1-.44-.55.5.5,0,0,1,.55-.44,60.32,60.32,0,0,0,6.45.35,58.27,58.27,0,0,0,48-25.23.49.49,0,0,1,.69-.12.49.49,0,0,1,.13.69A59.25,59.25,0,0,1,87.56,427.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.513px 414.409px"
    },
    id: "el3p46y3x31xl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.29,423.86a.53.53,0,0,1-.24-.06,59.38,59.38,0,0,1-29.58-37.94.5.5,0,0,1,.37-.6.49.49,0,0,1,.6.36,58.45,58.45,0,0,0,29.08,37.3.49.49,0,0,1,.21.67A.5.5,0,0,1,92.29,423.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "77.6228px 404.552px"
    },
    id: "elgsc9xd9to1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.62,423.25a.46.46,0,0,1-.23-.06c-1.51-.78-3-1.64-4.43-2.56a.5.5,0,1,1,.54-.84c1.41.9,2.87,1.74,4.35,2.51a.5.5,0,0,1-.23.95Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.4201px 421.473px"
    },
    id: "elx3hjc2yjo1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,418.85a.52.52,0,0,1-.29-.09,59.49,59.49,0,0,1-7.14-6.05,58.85,58.85,0,0,1-16.59-31.42.5.5,0,0,1,1-.18A57.82,57.82,0,0,0,86.75,412a59,59,0,0,0,7,5.94.5.5,0,0,1,.12.7A.51.51,0,0,1,93.48,418.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "81.7075px 399.771px"
    },
    id: "elpcbj71ut0w9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47,420.29a.47.47,0,0,1-.25-.07,59.36,59.36,0,0,1-28.87-39.05.52.52,0,0,1,.39-.6.51.51,0,0,1,.59.39,58,58,0,0,0,15.93,29,58.59,58.59,0,0,0,12.45,9.41.5.5,0,0,1,.2.68A.51.51,0,0,1,108.47,420.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "94.1565px 400.426px"
    },
    id: "elhs9nxa29adc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.38,379.18a.49.49,0,0,1-.49-.41c-.25-1.4-.44-2.82-.58-4.23a.5.5,0,1,1,1-.1c.14,1.39.33,2.78.57,4.16a.48.48,0,0,1-.41.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "79.0983px 376.583px"
    },
    id: "elv6hpeacwt6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,352.26a.49.49,0,0,1-.49-.43c-.21-1.44-.47-2.9-.78-4.32a.5.5,0,0,1,.38-.6.49.49,0,0,1,.59.38c.32,1.46.59,2.94.8,4.4a.51.51,0,0,1-.43.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "125.611px 349.579px"
    },
    id: "el8g8sg3m6lnf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.4,344.73a.5.5,0,0,1-.48-.37c-.32-1.15-.68-2.3-1.07-3.43a59.29,59.29,0,0,0-4.18-9.38.5.5,0,1,1,.87-.49,60.39,60.39,0,0,1,4.25,9.54c.4,1.15.76,2.33,1.09,3.49a.51.51,0,0,1-.35.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "121.744px 337.756px"
    },
    id: "elu74lq8gm8mk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.06,350.81a.49.49,0,0,1-.48-.36c-.28-1-.59-1.95-.92-2.9A58.07,58.07,0,0,0,109.8,331a.5.5,0,0,1,.09-.7.51.51,0,0,1,.7.09,59.18,59.18,0,0,1,9,16.79c.33,1,.64,2,.93,2.95a.5.5,0,0,1-.34.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.118px 340.505px"
    },
    id: "elu0qp00ld7er",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.87,347.85a.5.5,0,0,1-.44-.27A57.84,57.84,0,0,0,97.72,332a.5.5,0,1,1,.69-.72,58.69,58.69,0,0,1,11.91,15.89.51.51,0,0,1-.22.68A.59.59,0,0,1,109.87,347.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.956px 339.488px"
    },
    id: "eleju61qg8qfw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.14,368.38a.5.5,0,0,1-.37-.17,58.66,58.66,0,0,0-9.61-8.37c-1.55-1.08-3.19-2.11-4.85-3a.5.5,0,0,1,.49-.87c1.69.95,3.35,2,4.93,3.09a59.38,59.38,0,0,1,9.78,8.52.5.5,0,0,1,0,.7A.51.51,0,0,1,143.14,368.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "135.866px 362.151px"
    },
    id: "elln46b4iup7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,371.46a.51.51,0,0,1-.31-.11.5.5,0,0,1-.08-.7,59.45,59.45,0,0,1,72.46-16.14.5.5,0,0,1,.22.67.49.49,0,0,1-.67.22,58.46,58.46,0,0,0-71.23,15.87A.51.51,0,0,1,54,371.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.9228px 359.959px"
    },
    id: "el8dxgoy8immw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.87,375.36a.52.52,0,0,1-.36-.16,58.31,58.31,0,0,0-82.44-1.74.5.5,0,0,1-.7-.72,59.27,59.27,0,0,1,83.86,1.77.5.5,0,0,1,0,.71A.52.52,0,0,1,142.87,375.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "101.299px 365.793px"
    },
    id: "elff4sm6ssg6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.24,382.38a.47.47,0,0,1-.28-.09.5.5,0,0,1-.13-.7,60.59,60.59,0,0,1,5.48-6.76.5.5,0,0,1,.73.69,58.84,58.84,0,0,0-5.39,6.65A.51.51,0,0,1,52.24,382.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "54.9587px 378.526px"
    },
    id: "elongv164aj3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.25,384.75a.48.48,0,0,1-.36-.16,61.08,61.08,0,0,0-4.89-4.48.5.5,0,0,1-.07-.7.49.49,0,0,1,.7-.07,58,58,0,0,1,5,4.56.48.48,0,0,1,0,.7A.46.46,0,0,1,142.25,384.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "139.8px 381.988px"
    },
    id: "el3rdzvccunfs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.93,392.1a.47.47,0,0,1-.28-.09.5.5,0,0,1-.13-.7A59.23,59.23,0,0,1,134,376.56a.5.5,0,0,1,.12.69.51.51,0,0,1-.7.13,58.2,58.2,0,0,0-81,14.51A.48.48,0,0,1,51.93,392.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "92.8193px 379.014px"
    },
    id: "elagpk1p97rwq",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatInSpace);
export default __webpack_public_path__ + "static/media/catInSpace.2ee3602ff1023edcc38f5ef7d2420417.svg";
export { ForwardRef as ReactComponent };